module.exports = __webpack_public_path__ + "static/img/bg_fr.5d38cbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hlSaled-2025/bg_fr.png
// module id = atEf
// module chunks = 1